<template>
  <div class="plane-choose-passenger" :class="{'isiOSX':isiOSX}">
    <van-nav-bar
      title="选择乘机人"
      right-text="确定"
      left-arrow
      @click-left="reBack"
      @click-right="onClickRight"
    />
    <div class="content">
      <p class="tip">提示：为了确保您能顺利出行，请确保旅行结束日期至少比证件有效期早6个月</p>
      <van-row class="listAll" v-for="(item,index) in peopleList" :key="index">
        <van-col span="24" class="list">
          <p>
            姓名
            <span class="name">{{item.name}}（{{item.adult}}）</span>
          </p>
          <p class="card">
            证件号
            <span class="IDcard">{{item.id_number+'（'+(item.id_type==1?'身份证':'出生证明')+'）'}}</span>
          </p>
          <p>
            <img
              v-if="!item.selected"
              @click="Passenger(item)"
              class="selectPassenger"
              src="../../assets/plane/noselect@2x.png"
            />
            <img
              v-if="item.selected"
              @click="Passenger(item)"
              class="selectPassenger"
              src="../../assets/plane/delected@2x.png"
            />
            <span class="editor" @click="showPopup(item)">
              <img src="../../assets/plane/delect@2x.png" />删除
            </span>
            <span class="editor" @click="editor(item)">
              <img src="../../assets/plane/editor@2x.png" />编辑
            </span>
          </p>
        </van-col>
      </van-row>
      <div class="listAll loading" v-if="peopleList.length <= 0 && hasPassenger">
	    	<img src="../../assets/common/loading.gif"/>
	    </div>
	    <van-row class="empty_list" v-if="!hasPassenger">
	      <van-col class="emptyMsg" span="24">
	        <img src="../../assets/plane/noOrder.png" />
	        <p class="tip1">暂无乘机人</p>
	        <p class="btn">
	          <span @click="reBack">返回</span>
	        </p>
	      </van-col>
	    </van-row>
	  </div>
	  
  	<van-popup v-model="show">
    	<div class="box">
    		<img src="../../assets/common/BG@2x.png" alt="" />
    		<p class="title">温馨提示</p>
    		<p class="tips">亲，您真的要删除该乘机人吗？</p>
    		<span class="left" @click="cancle()">取消</span>
    		<span class="right" @click="confirm()">确认</span>
    	</div>
    </van-popup>
    <van-popup class="tipMSG" v-model="showTip">
    	<div class="box">
    		<img src="../../assets/common/BG@2x.png" alt="" />
    		<p class="title">温馨提示</p>
    		<p class="tips">{{TipMsg}}</p>
    		<span class="left" @click="cancleTip()">取消</span>
    		<span class="right" @click="confirmTip()">确定</span>
    	</div>
    </van-popup>
    <div class="btn-new">
      <van-button @click="newly" type="default" size="large">新增</van-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      peopleList: [],
      passengerLists: [],
      passengerLen: 0,
      isiOSX: false,
      delectItem: {},
      show: false,
      hasPassenger: true,
      adults: [],
      noChild: {},
      child_allow: false,
      baby_allow: false,
      showTip: false,
      TipMsg: '',
      tipBack: 1,
    };
  },

  methods: {
    reBack() {
      this.$router.go(-1);
    },
    onClickRight() {
      this.passengerLists = this.peopleList.filter(_ => {
        if (_.selected) {
        	if(_.birthday.length == 8) {
	        	_.birthday =
	          _.birthday.slice(0, 4) +
	          "-" +
	          _.birthday.slice(4, 6) +
	          "-" +
	          _.birthday.slice(6, 8);
	        }
          return _;
        }
      });
      if(this.passengerLists.length > 9) {
      	this.$toast("最多可添加9人");
      }else {
      	this.adults = this.passengerLists.filter(function(item) {
          if (item.adult == "成人") {
            return item;
          }
        });
        if(this.adults.length > 0) {
        	sessionStorage.setItem(
		        "passengerLists",
		        JSON.stringify(this.passengerLists)
		      );
		      this.$router.go(-1);
        }else {
        	this.$toast("成人数不能为0");
        }
      }
      
    },
    //获取宾客列表
    getInfoList() {
      this.$api
        .post("member/member/guests/list")
        .then(res => {
        	if(res.list.length == 0) {
        		this.hasPassenger = false;
        		this.peopleList = [];
        		return;
        	}
          this.peopleList = res.list;
          this.peopleList.forEach(_ => {
            var date = _.id_number || "";
            if (date.length == 18) {
              var a = date.substring(6, 14);
              var time_adult =
                a.slice(0, 4) + "-" + a.slice(4, 6) + "-" + a.slice(6);
              var millisecond =
                new Date("2019-01-01").getTime() -
                new Date("2007-01-01").getTime();
            	var millisecond_1 =
                new Date("2019-01-01").getTime() -
                new Date("2017-01-01").getTime();
              var times1 =
                new Date().getTime() - new Date(time_adult).getTime();
              if (times1 >= millisecond) {
                _.adult = "成人";
                _.person_type = 1;
              }else if(times1 >= millisecond_1 && times1 < millisecond) {
              	_.adult = "儿童";
                _.person_type = 2;
              }else {
              	_.adult = "婴儿";
                _.person_type = 3;
              }
            } else if (date.length == 8) {
              var time_child =
                date.slice(0, 4) + "-" + date.slice(4, 6) + "-" + date.slice(6);
                var millisecond =
                new Date("2019-01-01").getTime() -
                new Date("2007-01-01").getTime();
              var millisecond_1 =
                new Date("2019-01-01").getTime() -
                new Date("2017-01-01").getTime();
              var times2 =
                new Date().getTime() - new Date(time_child).getTime();
              if(times2 >= millisecond){//此处是为了处理录入时是婴儿现在已是成人的乘客
              	_.adult = "成人";
                _.person_type = 1;
              }else if (times2 >= millisecond_1) {//此处是为了处理录入时是婴儿现在已是儿童的乘客
                _.adult = "儿童";
                _.person_type = 2;
              }else {
              	_.adult = "婴儿";
                _.person_type = 3;
              }
            }
          });
          this.initPepleList();
        })
        .catch(err => {
	        let keys = Object.keys(err);
		     	let key = keys[0];
		  		let message = err.message || err[key][0]
			    //this.$toast(message);
			    if(message.slice(0, 10) == 'timeout of') {
		  			this.$toast('网络不给力，请稍候重试');
		  		}else {
		  			this.$toast(message);
		  		}
        });
    },
    Passenger(item) {
    	if(this.passengerLen >= 9 && !item.selected) {
    		this.$toast("最多可添加9人");
    	}else {
	      //该航班不支持儿童票he该航班不支持婴儿票 的情况已在舱位列表处理过（不做展示）
        if(!this.child_allow && item.adult == "儿童") {//不携带儿童但是选择儿童时
          item.selected = false;
          this.showPopupTip('请前往机票首页勾选儿童票');

        }else if(!this.baby_allow && item.adult == "婴儿") {//不携带婴儿但是选择婴儿时
          item.selected = false;
          this.showPopupTip('请前往机票首页勾选婴儿票');

        }else {//成人、儿童、婴儿都可选
          if(item.adult == "儿童" && item.id_number.length == 8) {
		      	this.$toast("请重新编辑该用户信息");
		      }else {
		      	item.selected = !item.selected;
	        	this.peopleList = [...this.peopleList];
	        	if(item.selected) {
	        		this.passengerLen = this.passengerLen + 1;
	        	}else {
	        		this.passengerLen = this.passengerLen - 1;
	        	}
		      }
        }
      }
    },
    showPopupTip(msg) {
	      this.showTip = true;
	      this.TipMsg = msg;
    },
    //新增宾客
    newly() {
      this.$router.push("/add/passenger");
    },
    //编辑
    editor(item) {
      this.$router.push({
        path: "/add/passenger",
        query: { id: item.id }
      });
    },
    //删除
    showPopup(item) {
	      this.show = true;
	      this.delectItem = item;
    },
  	cancle() {
    	this.show = false;
    },
  	confirm() {
  		this.show = false;
  		this.$api
        .get("member/member/guests/delete", {
          id: this.delectItem.id
        })
        .then(res => {
          this.getInfoList();
        })
        .catch(err => {
	        let keys = Object.keys(err);
		     	let key = keys[0];
		  		let message = err.message || err[key][0]
			    //this.$toast(message);
			    if(message.slice(0, 10) == 'timeout of') {
		  			this.$toast('网络不给力，请稍候重试');
		  		}else {
		  			this.$toast(message);
		  		}
        });
    },
    cancleTip() {
    	this.showTip = false;
    },
  	confirmTip() {
  		this.showTip = false;
  		this.$router.go(-4);
  	},
    initPepleList() {
      this.peopleList.forEach(a => {
        this.passengerLists.forEach(_ => {
          if (_.name == a.name) {
            a.selected = true;
	        	this.passengerLen = this.passengerLen + 1;
          }
        });
      });
      this.peopleList = [...this.peopleList];
    }
  },
  mounted() {
  	this.isiOSX = this.isIphoneX();
    this.getInfoList();
    this.passengerLists = JSON.parse(
      sessionStorage.getItem("passengerLists") || "[]"
    );
    this.noChild =  JSON.parse(sessionStorage.getItem("create"));
    if (this.noChild.info.child_quantity != 0) {
      this.child_allow = true;
    }
    if (this.noChild.info.baby_quantity != 0) {
      this.baby_allow = true;
    }
  }
};
</script>
<style lang="less">
.plane {
  &-choose-passenger {
    height: 100%;
    background: #f2f2f2;
    .van-nav-bar {
      background: #f2f2f2;
      padding-top: 24px;
      position: fixed;
      top: 0;
      width: 100%;
      .van-nav-bar__title {
        font-size: 18px;
        color: #333;
      }
      .van-nav-bar__text {
        color: #333;
        font-size: 14px;
      }
      .van-icon-arrow-left:before {
        display: none;
      }
      .van-nav-bar__left {
        left: 11px;
        .van-icon {
          width: 17px;
          height: 15px;
          display: inline-block;
          background: url(../../assets/plane/reBack.png) no-repeat center center;
          background-size: 100% 100%;
        }
      }
    }
    .content {
      padding: 70px 16px 60px 7px;
      position: relative;
      background: #f2f2f2;
			margin-top: 66px;
      .tip {
      	width: calc(100% - 22px);
        padding: 7px 11px;
        color: #f79b23;
        font-size: 11px;
        background: #ffe8c1;
        position: absolute;
        top: 0;
        left: 0;
        line-height: 19px;
      }
      .listAll {
        .list {
          margin-bottom: 7px;
          background: #fff;
          border-radius: 7px;
          box-shadow: #e3e3e3 1px 0 3px;
          padding: 0 6px 0 15px;
          p {
            height: 52px;
            line-height: 52px;
            color: #333;
            font-size: 13px;
            .name {
              padding-left: 76px;
            }
            .IDcard {
              padding-left: 61px;
            }
            .selectPassenger {
              width: 14px;
            }
            .editor {
              float: right;
              margin-left: 17px;
              img {
                width: 14px;
                float: left;
                margin-top: 18px;
                margin-right: 7px;
              }
            }
            @media only screen and (min-width: 320px) and (max-width: 374px){
				      .name {
				        padding-left: 51px;
				      }
				      .IDcard {
	              padding-left: 36px;
	            }
				    }
          }
          .card {
            border-top: solid 1px #f0efef;
            border-bottom: solid 1px #f0efef;
          }
        }
      }
      .loading{
	    	text-align: center;
	    	img {
	    		width: 35%;
	    		margin-top: 50%;
	    	}
	    }
	    .empty_list {
	      padding-top: 66px;
	      .emptyMsg {
	        padding: 0 93px;
	        text-align: center;
	        img {
	          width: 100%;
	          display: block;
	        }
	        .tip1 {
	          color: #b9b9b9;
	          font-size: 15px;
	          height: 51px;
	          line-height: 51px;
	          margin-bottom: 12px;
	        }
	        .btn {
	          text-align: center;
	          span {
	            width: 110px;
	            height: 32px;
	            line-height: 32px;
	            color: #ff6059;
	            display: inline-block;
	            border: solid 1px rgba(255, 96, 89, 0.4);
	            border-radius: 16px;
	            box-shadow: rgba(255, 96, 89, 0.1) 3px 0 6px;
	          }
	        }
	      }
	    }
    }
		.van-popup--center{
			width: 70%;
			border-radius: 10px;
			.box {
				img {
					display: block;
					width: 100%;
				}
				.title {
					color: #333;
					font-size: 15px;
					font-weight: 600;
					line-height: 47px;
					margin-top: 8px;
					text-align: center;
				}
				.tips {
					color: #333;
					font-size: 13px;
					line-height: 18px;
					text-align: center;
					margin-bottom: 30px;
				}
				span {
					float: left;
					width: 50%;
					border-top: solid 1px #F2F2F2;
					line-height: 43px;
					color: #999;
					font-size: 14px;
					text-align: center;
					display: inline-block;
				}
				.right {
					color: #E6212F;
					width: calc(50% - 1px);
					border-left: solid 1px #F2F2F2;
				}
			}
		}
		.tipMSG{
			width: 70%;
			border-radius: 10px;
			.box {
				img {
					display: block;
					width: 100%;
				}
				.title {
					color: #333;
					font-size: 15px;
					font-weight: 600;
					line-height: 47px;
					margin-top: 8px;
					text-align: center;
				}
				.tips {
					color: #333;
					font-size: 13px;
					line-height: 18px;
					text-align: center;
					margin-bottom: 30px;
					padding: 0 10px;
				}
				span {
					float: left;
					width: 50%;
					border-top: solid 1px #F2F2F2;
					line-height: 43px;
					color: #999;
					font-size: 14px;
					text-align: center;
					display: inline-block;
				}
				.right {
					color: #E6212F;
					width: calc(50% - 1px);
					border-left: solid 1px #F2F2F2;
				}
			}
		}
    .btn-new {
      box-sizing: border-box;
      padding: 0 11px;
      position: fixed;
      padding-bottom: 20px;
      background: #f2f2f2;
      bottom: 0px;
      width: 100%;
      .van-button--large {
      	color: #fff;
        height: 34px;
        line-height: 34px;
        background: linear-gradient(
          0deg,
          rgba(255, 96, 89, 1) 0%,
          rgba(254, 172, 122, 1) 100%
        );
        border-radius: 17px;
      }
    }
  }
}
.isiOSX {
	.van-nav-bar {
		padding-top: 44px;
	}
	.content {
		padding-top: 90px;
		.tip {
			top: 20px;
		}
	}
}
</style>